// React&NextJS
import React from 'react'
// Components
import Authentication from '../components/components/authentication/Authentication'
import { Section } from '../components/core/section/Section'
import Meta from '../components/meta/Meta'

type Props = {
    authData: {
        create: Boolean
        success: Boolean
        customToken?: string
        message?: string
        ssn?: string
    }
}

export default function SignUp({ authData }: Props) {
    return (
        <Section>
            <Meta
                title="Minningar - Innskráning"
                seoTitle="Minningar - Innskráning"
                description="Síða þar sem notendur geta stofnað aðgang."
                url="https://minningar.is/sign-up"
                image="https://ik.imagekit.io/minningar/Minningar_7V4A5213_01-min_5-f7B_aBV.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1643189239548&tr=w-1200%2Ch-628%2Cfo-auto"
                type="website"
            />
            <Authentication authData={authData} />
        </Section>
    )
}
